import { Injector } from "@angular/core";
import { EntityEnum } from "../../EntityEnum";
import { DevelopmentProductAutoUploadEntity } from "../Entity/DevelopmentProductAutoUploadEntity";
import { DevelopmentProductEntityListView } from "../../../Data/MedicinalProductData/DevelopmentProductEntityListView";
import { BaseNode } from "../../BaseNode";
import { OnDemandSimpleSearchListNode } from "../../OnDemandSimpleSearchListNode";


export class TreeNodeMedicinalProductsDevelopmentProduct extends OnDemandSimpleSearchListNode {
    useHist: boolean = false;
    constructor(injector: Injector, items: any[]|undefined, useHist:boolean) {
        super(injector, new DevelopmentProductEntityListView(items), "Development Medicinal Products", useHist ? EntityEnum.developmentProductHist : EntityEnum.developmentProduct);
        this.useHist = useHist;
    }


    override addChild(model: any): BaseNode|undefined {
        const labelTemplate = `Development - ${model.ev_Code} - ${model.version} ${model.productname?" - " + model.productname:model.productothername?" - " +model.productothername:''}`;
        return this.addChildNode(DevelopmentProductAutoUploadEntity,labelTemplate,this,model,this.useHist, false,false);
    }

    override getCriteriaFields(): string[] {
        return ['ev_Code','productname', "productcode", "productnamevariation"];
    }

    override getPlaceHolderTemplate(): string {
        return "Search for product records owned in the XEVMPD by your HQ";
    }
}